import { render, staticRenderFns } from "./BaseLearningOutcomeAndCriterion.vue?vue&type=template&id=1918c14f&scoped=true&"
import script from "./BaseLearningOutcomeAndCriterion.vue?vue&type=script&lang=js&"
export * from "./BaseLearningOutcomeAndCriterion.vue?vue&type=script&lang=js&"
import style0 from "./BaseLearningOutcomeAndCriterion.vue?vue&type=style&index=0&id=1918c14f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1918c14f",
  null
  
)

export default component.exports